import PillarChapterHeader from './PillarChapterHeader'

export default PillarChapterHeader